<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel>
          <lay-form :model="search" style="text-align: start" size="sm">
            <lay-form-item label="账号" prop="key" mode="inline">
              <lay-input v-model="search.key" placeholder="请输入账号"></lay-input>
            </lay-form-item>
            <lay-form-item label="角色" prop="state" mode="inline">
              <lay-select v-model="search.state" placeholder="请选择">
                <lay-select-option :value="0" label="全部"></lay-select-option> 
                <lay-select-option v-for="role in roleArr1" :value="role.id" :label="role.title"></lay-select-option> 
              </lay-select>
            </lay-form-item>
            <lay-form-item mode="inline">
              <lay-button type="primary" size="sm" @click="searchUser">查询</lay-button>
            </lay-form-item>
  
          </lay-form>
         
  
          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">
  
            <template #state="{ row }">
              <lay-switch :model-value="row.state == 0 ? true : false" @change="changedelFlag(row)" onswitch-text="正常"
                unswitch-text="禁用"></lay-switch>
            </template> 
            <template v-slot:operator="{ row }"> 
              <lay-button size="xs" type="primary" @click="updateUser(row)">编辑</lay-button> 
            </template>
   
          </lay-table>
        </lay-panel>
      </lay-col>
    </lay-row>
    <lay-layer v-model="visible11" :shade="false" :area="['400px', '530px']" :btn="action11" title="添加/修改">
      <div style="padding: 20px;">
        <lay-form :model="user" ref="layFormRef11" :pane="true">
  
          <lay-form-item label="账户" prop="userName">
            <lay-input v-model="user.userName" :disabled="isDisabled" placeholder="请输入账号"></lay-input>
          </lay-form-item>
          <lay-form-item label="邮箱" prop="email">
            <lay-input v-model="user.email"  disabled placeholder="邮箱"></lay-input>
          </lay-form-item>  
  
          <lay-form-item label="密码" prop="password">
            <lay-input v-model="user.password" type="password" placeholder="无需修改请置空"></lay-input>
          </lay-form-item>  


        
  
          <lay-form-item label="会员时间" prop="endTime"> 
            <lay-date-picker type="datetime" v-model="user.endTime" placeholder="会员时间"></lay-date-picker>
          </lay-form-item>  

          <lay-form-item label="金币" prop="gold"> 
   
            <lay-input v-model="user.gold"  placeholder="金币"></lay-input>
          </lay-form-item>  


   
  
          <lay-form-item label="备注" prop="generalRemark">
            <lay-textarea placeholder="请输入备注" v-model="user.remark"></lay-textarea>
          </lay-form-item>
  
        </lay-form>
      </div>
    </lay-layer>
  </template>
    
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allWebUser, disableUsers,webModifyUser} from '../../../api'
  import { setToken,setUserName } from '../../../utils/auth' 
  
  const platformArr = ref([]);
  


  
  
  const roleArr1 = ref([]);
  const roleArr2 = ref([]);
  
   
  
  const search = reactive({
    key: ""
  })
  
  
  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([
    { title: "账号", key: "userName", align: "center" },
    { title: "邮箱", key: "email", align: "center" },
    { title: "金币", key: "gold", align: "center" }, 
    { title: "到期时间", key: "endTime", align: "center" },
    { title: "平台", key: "platform", align: "center" },
    { title: "状态", key: "state", align: "center", customSlot: "state" }, 
    { title: "备注", key: "remark", align: "center" , ellipsisTooltip: true},
    { title: "添加时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center", width: "160px" }
  ]);
  

  const getAllAdminUser = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key};
    allWebUser(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAdminUser();
  
  
  const change = (page: any) => {
    getAllAdminUser();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
  //禁用或者开启
  const changedelFlag = (row: any) => {
    var data = { "key": row.userId, "id": row.state };
    disableUsers(JSON.stringify(data)).then((res: any) => {
      if (res != "" && res.code == 0) {
        getAllAdminUser();
        layer.msg("操作成功", { time: 1000, icon: 1 });
      }
    })
  }
  
  //查询接口
  const searchUser = () => {
    page.current = 1;
    getAllAdminUser();
  }
  
  const user = reactive({
    userId: "",
    userName: "",
    password: "", 
    remark: "", 
    email: "", 
    endTime: "", 
    gold: 0, 

   
  })
  
  
  const updateUser = (row: any) => {
    user.userId = row.userId;
    user.userName = row.userName;
    user.password = "";
    user.email = row.email; 
    user.remark = row.remark; 
    user.endTime = row.endTime; 
    user.gold = row.gold;  
   
    isDisabled.value = true;
    visible11.value = !visible11.value;
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);
  
 
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        webModifyUser(JSON.stringify(user)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllAdminUser();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
      }
    }
  ])
  
  
 
  </script>
    
   